import { useEffect } from "react";
import { useAuth } from "../../../contexts/AuthContext";

const Header = ({
  setScreenColor,
  screenColor,
  setIsStudentIDVisible,
  isLogin = true,
  isMypage = true,
}) => {
  const { user, mypageLogout } = useAuth();

  useEffect(() => {
    // html要素にCSSクラスを適用
    const mypageEl = document.querySelector("html");
    if (mypageEl.classList.contains("c-font-size--medium")) return;
    if (mypageEl.classList.contains("c-font-size--large")) return;
    mypageEl.classList.add("c-font-size--medium");
  }, []);

  // フォントサイズの変更ボタンクリック処理
  const handleChangeFontSize = (size) => {
    // html要素にCSSクラスを適用
    const mypageEl = document.querySelector("html");
    if (size === "size-large") {
      mypageEl.classList.remove("c-font-size--medium");
      mypageEl.classList.add("c-font-size--large");
    }
    if (size === "size-standard") {
      mypageEl.classList.remove("c-font-size--large");
      mypageEl.classList.add("c-font-size--medium");
    }
  };

  return (
    <header className="l-header">
      <div className="p-header-con">
        <div className="p-header-logo">
          <h1 className="p-header-logo__img">
            {isMypage ? (
              !isLogin ? (
                <img
                  src="/common/assets/images/logo01.svg"
                  alt="渋谷ハチコウ大学"
                />
              ) : (
                <a className="p-header-logo_link" href="/mypage/">
                  <img
                    src="/common/assets/images/logo01.svg"
                    alt="渋谷ハチコウ大学"
                  />
                </a>
              )
            ) : (
              <img src="/common/assets/images/logo02.svg" alt="シブカツ" />
            )}
          </h1>
        </div>
        <div className="p-pc-header__menu">
          <div className="p-pc-header__utility">
            <div className="p-pc-header__utility-top">
              <div className="p-pc-header__bg-color">
                <p className="p-pc-header__bg-color-txt">背景色変換</p>
                <div className="p-pc-header__bg-color-item">
                  <button
                    className={`c-color__btn--normal c-color__btn ${
                      screenColor === "color-standard" ? "is-active" : ""
                    }`}
                    onClick={() => setScreenColor("color-standard")}
                  >
                    白
                  </button>
                  <button
                    className={`c-color__btn--blue c-color__btn ${
                      screenColor === "color-blue" ? "is-active" : ""
                    }`}
                    onClick={() => setScreenColor("color-blue")}
                  >
                    青
                  </button>
                  <button
                    className={`c-color__btn--black c-color__btn ${
                      screenColor === "color-black" ? "is-active" : ""
                    }`}
                    onClick={() => setScreenColor("color-black")}
                  >
                    黒
                  </button>
                </div>
              </div>
              <div className="p-pc-header__font-size">
                <p className="p-pc-header__font-size-txt">文字サイズ</p>
                <div className="p-pc-header__font-size-item">
                  <button
                    className="c-font-size__btn--medium c-font-size__btn is-active"
                    onClick={() => handleChangeFontSize("size-standard")}
                  >
                    標準
                  </button>
                  <button
                    className="c-font-size__btn--large c-font-size__btn"
                    onClick={() => handleChangeFontSize("size-large")}
                  >
                    拡大
                  </button>
                </div>
              </div>
            </div>
            {isLogin && (
              <div className="p-pc-header__utility-bottom">
                <p className="p-pc-header__log">
                  ようこそ
                  <span className="p-pc-header__log-name">{user.name}</span>様
                </p>
                <a
                  className="p-pc-header__logout"
                  href="#"
                  onClick={mypageLogout}
                >
                  ログアウト
                </a>
              </div>
            )}
            {!isLogin && (
              <div className="p-pc-header__utility-bottom">
                <a
                  className="p-pc-header__btn"
                  href={process.env.REACT_APP_SHIBUKATSU_WEB_DOMAIN + "/"}
                >
                  シブカツトップページに戻る
                </a>
              </div>
            )}
          </div>
          {isLogin && (
            <div className="p-pc-header__proof">
              <div
                className="p-pc-header__proof-btn"
                href="#"
                onClick={() => setIsStudentIDVisible(true)}
              >
                学生証
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};
export default Header;
